import { render, staticRenderFns } from "./popup-batch-replace.vue?vue&type=template&id=1587cdd0&scoped=true"
import script from "./popup-batch-replace.vue?vue&type=script&lang=js"
export * from "./popup-batch-replace.vue?vue&type=script&lang=js"
import style0 from "./popup-batch-replace.vue?vue&type=style&index=0&id=1587cdd0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1587cdd0",
  null
  
)

export default component.exports